import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DOMPurify from "dompurify";
import { api } from "@/lib/api";
import { BrandLogo } from "@/components/Brand";

export default function Terms() {
  const [html, setHtml] = useState("");
  const [updatedAt, setUpdatedAt] = useState("");

  useEffect(() => {
    api.get("/platform/terms").then((r) => {
      setHtml(r.data.terms_html || "");
      setUpdatedAt(r.data.updated_at || "");
    }).catch(() => setHtml("<p>No pudimos cargar los términos.</p>"));
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-slate-200 sticky top-0 bg-white/90 backdrop-blur z-20">
        <div className="mx-auto max-w-3xl px-6 py-4 flex items-center justify-between">
          <Link to="/" data-testid="terms-back-home"><BrandLogo /></Link>
          <Link to="/signup" className="text-sm underline text-[hsl(var(--accent))]" data-testid="terms-go-signup">Empezar gratis →</Link>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-6 py-16">
        <p className="overline">Legal</p>
        <h1 className="font-display text-4xl sm:text-5xl font-light tracking-tight mt-3">Términos y Condiciones</h1>
        {updatedAt && <p className="text-xs text-slate-500 mt-3">Última actualización: {new Date(updatedAt).toLocaleString("es-MX")}</p>}
        <article
          className="prose prose-slate prose-sm sm:prose-base max-w-none mt-10"
          data-testid="terms-content"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html || "<p>Cargando…</p>") }}
        />
      </main>
    </div>
  );
}
